import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/lib/adminAuth";

export const AdminProtected = ({ children, masterOnly = false }) => {
    const { user } = useAdminAuth();
    if (user === undefined) {
        return (
            <div className="min-h-screen bg-[var(--bg)] text-muted grid place-items-center font-mono text-sm uppercase tracking-widest">
                Checking access…
            </div>
        );
    }
    if (!user) return <Navigate to="/admin/login" replace />;
    if (masterOnly && user.role !== "master_admin") {
        return <Navigate to="/admin" replace />;
    }
    return children;
};

export const AdminShell = ({ children, title, eyebrow, right }) => {
    const { user, signOut } = useAdminAuth();
    const navigate = useNavigate();
    const logout = () => {
        signOut();
        navigate("/admin/login");
    };
    return (
        <div className="min-h-screen bg-[var(--bg)] text-[var(--text)]">
            <header className="border-b border-[var(--border)] sticky top-0 bg-[var(--bg)]/95 backdrop-blur z-10">
                <div className="container-nk py-4 flex items-center justify-between gap-4">
                    <div className="flex items-center gap-4">
                        <Link to="/admin" className="flex items-center gap-3">
                            <div className="font-display text-xl tracking-tight">
                                naami<span className="text-gold">.</span>
                            </div>
                            <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-gold">
                                // Admin
                            </span>
                        </Link>
                    </div>
                    <div className="flex items-center gap-3">
                        {user?.role === "master_admin" && (
                            <Link to="/admin/settings" className="font-mono text-[10px] uppercase tracking-[0.22em] text-muted hover:text-gold" data-testid="admin-settings-link">
                                ⚙ Settings
                            </Link>
                        )}
                        <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-muted hidden md:block">
                            {user?.name} · {user?.role === "master_admin" ? "Master" : "Brand Owner"}
                        </span>
                        <button onClick={logout} className="btn-ghost" data-testid="admin-logout">
                            Sign out
                        </button>
                    </div>
                </div>
            </header>
            {(title || eyebrow || right) && (
                <div className="border-b border-[var(--border)]">
                    <div className="container-nk py-8 flex flex-wrap items-end justify-between gap-4">
                        <div>
                            {eyebrow && <p className="eyebrow mb-2">// {eyebrow}</p>}
                            {title && (
                                <h1 className="font-display text-[36px] md:text-[48px] leading-[0.95]">
                                    {title}
                                </h1>
                            )}
                        </div>
                        {right}
                    </div>
                </div>
            )}
            <main className="container-nk py-10">{children}</main>
        </div>
    );
};

export const Modal = ({ title, onClose, children }) => (
    <div className="fixed inset-0 bg-[var(--bg)]/85 backdrop-blur grid place-items-center z-50 p-6 overflow-y-auto" role="dialog">
        <div className="bg-[var(--surface)] border border-[var(--border)] w-full max-w-lg my-8 relative">
            <div className="border-b border-[var(--border)] px-6 py-4 flex items-center justify-between sticky top-0 bg-[var(--surface)]">
                <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-gold">// {title}</span>
                <button onClick={onClose} className="font-mono text-[10px] uppercase tracking-[0.22em] text-muted hover:text-gold">Close ✕</button>
            </div>
            <div className="p-6">{children}</div>
        </div>
    </div>
);
